"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutsModal_1 = __importDefault(require("./ShortcutsModal"));
exports.default = ShortcutsModal_1.default;
